export const GET_ASSIGNEE = "GET_ASSIGNEE";
export const CHANGE_ASSIGNEE = "CHANGE_ASSIGNEE";
